import axios from 'axios'
import qs from 'qs'
const service = axios.create({
    // baseURL: "./mock",
    timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token        
        // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 

        if (config.method === 'post') { // post请求时，处理数据
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
            config.data = qs.stringify({
                ...config.data //后台数据接收这块需要以表单形式提交数据，而axios中post默认的提交是json数据,所以这里选用qs模块来处理数据，也有其他处理方式，但个人觉得这个方式最简单好用
            })
        }
        const token = "admin_token";
        token && (config.headers.Authorization = token);
        return config;
    },
    error => {
        return Promise.error(error);
    })
// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        return res
    }
)

export default service